import React from "react";
import { NavLink } from "react-router-dom";
import { isMobile } from "react-device-detect";
import SearchBox from "../SearchBox/SearchBox.jsx";

class GamesLeftNav extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isBodyVisible: true,
            showSearchResults: isMobile && this.props.showCasinoSearchPopup ? this.props.showCasinoSearchPopup : false,
            searchResults: [],
            searchString: ""
        };
        this.logClick = this.logClick.bind(this);
    }

    logClick() {
        const thisComponent = this;
        if (isMobile) {
            thisComponent.props.togglePanel(false);
        }
    }

    handleHeaderClick() {
        this.setState({
            isBodyVisible: !this.state.isBodyVisible
        });
    }

    headerNavigation(direction) {
        function isInViewport(el, container) {
            const { left, right, width } = el.getBoundingClientRect();
            const containerRect = container.getBoundingClientRect();
            return {
                elementWidth: Math.ceil(width),
                willBeInViewport: left - 200 < containerRect.width,
                isInViewport: left <= containerRect.left ? containerRect.left - left <= width + 50 : right - containerRect.right <= width - 50
            };
        }
        const elementToScroll = document.getElementById("casino-links");
        const childNodes = document.getElementById("casino-links").childNodes;
        const childNodesArray = Array.from(childNodes);
        const leftpos = elementToScroll.dataset.leftpos;
        let lastElementVisible = false;
        const allLinks = childNodesArray.filter((n) => n.classList.contains("btn"));
        const lastIndex = Object.keys(allLinks).pop();
        const lastElement = allLinks[lastIndex];
        let isInView = isInViewport(lastElement, document.getElementById("casino-link-container"));
        lastElementVisible = isInView.isInViewport;

        let newLeftpos = direction === "right" ? (leftpos * 1 - 500) : (leftpos * 1 + 500);
        if (isInView.willBeInViewport && direction === "right") {
            newLeftpos = leftpos * 1 - isInView.elementWidth;
        }
        newLeftpos = newLeftpos > 0 ? 0 : newLeftpos;
        document.getElementById("casino-header-nav-left").classList.remove("disabled");
        document.getElementById("casino-header-nav-right").classList.remove("disabled");
        if ((leftpos >= 0 && direction === "left") || (lastElementVisible && direction === "right")) {
            if (direction === "left") {
                document.getElementById("casino-header-nav-left").classList.add("disabled");
            } else {
                document.getElementById("casino-header-nav-right").classList.add("disabled");
            }
            return false;
        }

        elementToScroll.style.left = newLeftpos + "px";
        elementToScroll.dataset.leftpos = newLeftpos;
        setTimeout(() => {
            isInView = isInViewport(lastElement, document.getElementById("casino-link-container"));
            if (isInView.isInViewport) {
                document.getElementById("casino-header-nav-right").classList.add("disabled");
            }
            if (elementToScroll.getAttribute("leftpos") >= 0) {
                document.getElementById("casino-header-nav-left").classList.add("disabled");
            }
        }, 350);
    }

    componentDidMount() {
        if (!isMobile) {
            const navContainer = document.getElementById("casino-link-container");
            const childNodes = document.getElementById("casino-links").childNodes;
            const childNodesArray = Array.from(childNodes);
            let linksWidth = 0;
            if (childNodesArray) {
                const allLinks = childNodesArray.filter((n) => n.classList.contains("btn"));
                allLinks.forEach((element) => {
                    linksWidth += element.offsetWidth;
                });
            }
            if (linksWidth > navContainer.offsetWidth) {
                document.getElementById("casino-header-nav-right").classList.remove("d-none");
                document.getElementById("casino-header-nav-left").classList.remove("d-none");
            }
        }
    }

    render() {
        const className = this.state.isBodyVisible ? "widgetHeader" : "collapsed widgetHeader";
        const bodyVisibleStyle = this.state.isBodyVisible ? {} : { "display": "none" };
        return (
            <div className={"popularLinks widget" + (!isMobile ? " d-flex" : "")}>
                {isMobile &&
                    <>
                        <span className={className} onClick={this.handleHeaderClick.bind(this)}><i className="arrow" /> Casino</span>
                        <div style={bodyVisibleStyle}>

                            <NavLink exact onClick={this.logClick} className={(isActive) => {
                                return "btn" + (isActive ? " host-active" : "");
                            }} to="/casino">Casino Home</NavLink>

                            {(this.props.userContext !== undefined) &&

                                <NavLink exact onClick={this.logClick} to="/casino/favourites" className={(isActive) => {
                                    return "btn" + (isActive ? " host-active" : "");
                                }} >
                                    <span className="host-count" id="Favourites_Count">({this.props.favouritesData.length})</span>
                                    Favourites
                                </NavLink>
                            }

                            {this.props.groupData.map((item, key) => {

                                return (
                                    <NavLink
                                        key={key}
                                        exact
                                        onClick={this.logClick}
                                        className={(isActive) => {
                                            return "btn" + (isActive ? " host-active" : "");
                                        }}
                                        to={"/casino/" + item.id}
                                    >
                                        {item.gamesDetails &&
                                            <span className="host-count">({item.gamesDetails.length})</span>
                                        }
                                        <span className="host-name">{item.name}</span>
                                    </NavLink>);
                            }
                            )}

                        </div>
                    </>
                }
                {!isMobile &&
                    <>
                        <span className="material-icons navigation-arrow disabled d-none noselect" id="casino-header-nav-left" onClick={this.headerNavigation.bind(this, "left")}>chevron_left</span>
                        <div className="casino-links-container" id="casino-link-container">
                            <div id="casino-links" data-leftpos="0">
                                <NavLink exact onClick={this.logClick} className={(isActive) => {
                                    return "btn" + (isActive ? " host-active" : "");
                                }} to="/casino">{this.props.casinoHasHorizontalNav ? "Home" : "Casino Home"}</NavLink>

                                {(this.props.userContext !== undefined) && this.props.favouritesData.length > 0 &&
                                    <>
                                        <span className="separator"></span>
                                        <NavLink exact onClick={this.logClick} to="/casino/favourites" className={(isActive) => {
                                            return "btn" + (isActive ? " host-active" : "");
                                        }}>
                                            Favourites
                                            <span className="host-count" id="Favourites_Count">({this.props.favouritesData.length})</span>
                                        </NavLink>
                                    </>
                                }

                                {this.props.groupData.map((item, key) => {
                                    return (
                                        <React.Fragment key={key}>
                                            <span className="separator"></span>
                                            <NavLink
                                                exact
                                                onClick={this.logClick}
                                                className={(isActive) => {
                                                    return "btn" + (isActive ? " host-active" : "");
                                                }}
                                                to={"/casino/" + item.id}
                                            >
                                                <span className="host-name">{item.name}</span>
                                            </NavLink>
                                        </React.Fragment >
                                    );
                                }
                                )}
                            </div>
                        </div>
                        <span className="material-icons navigation-arrow d-none noselect" id="casino-header-nav-right" onClick={this.headerNavigation.bind(this, "right")}>chevron_right</span>
                    </>
                }
                {!isMobile &&
                    <SearchBox
                        groupData={this.props.groupData}
                        controller={this.props.controller}
                        gamesIndex={this.props.gamesIndex}
                        favouritesData={this.props.favouritesData}
                        onUpdateFavourites={this.props.onUpdateFavourites}
                        cdnLocation={this.props.cdnLocation}
                        userContext={this.props.userContext}
                        onPlayGame={this.props.onPlayGame}
                        onSearchForGames={this.props.onSearch}
                        searchResults={this.props.searchResults}
                        recommendedGames={this.props.recommendedGames}
                    />
                }
            </div>
        );
    }
}

export default GamesLeftNav;